<template>
  <div v-if="elementInfo" class="editable-element-section"
       :class="{ 'lock': elementInfo.lock }"
       :style="{
      top: elementInfo.top + 'px',
      left: elementInfo.left + 'px'
    }"
       @click="selectElement()"
  >
    <div
        class="rotate-wrapper"
        :style="{ transform: `rotate(${elementInfo.rotate}deg)` }"
    >
      <div
          class="element-content"
          :style="{
          backgroundColor: elementInfo.fill,
          padding: '4px'
        }"
          v-contextmenu="contextmenus"
          @mousedown="$event => handleSelectElement($event)"
          @touchstart="$event => handleSelectElement($event)"
          @dblclick="openDataEditor()"
      >
        <ElementOutline
            :width="elementInfo.width"
            :height="elementInfo.height"
            :outline="elementInfo.outline"
        />
        <SlideLayoutElement
            v-if="slideLayoutElement"
            :key="slideLayoutElement.id"
            :elementInfo="slideLayoutElement"
            :elementIndex="2"
            :isMultiSelect="false"
            :selectElement="selectElement"
            :openLinkDialog="null"
        />
</div>
      </div>
    </div>
</template>

<script lang="ts" setup>
import {PropType, computed, watch} from 'vue'
import { PPTSectionElement } from '@/types/slides'
import { ContextmenuItem } from '@/components/Contextmenu/types'
import emitter, { EmitterEvents } from '@/utils/emitter'
import SlideLayoutElement from '@/views/components/element/SlideLayoutElement/index.vue'
import ElementOutline from '@/views/components/element/ElementOutline.vue'
import {useMainStore, useSlidesStore} from "@/store";
const slidesStore = useSlidesStore()

const props = defineProps({
  elementInfo: {
    type: Object as PropType<PPTSectionElement>,
    required: true,
  },
  selectElement: {
    type: Function as PropType<(e: MouseEvent | TouchEvent, element: PPTSectionElement, canMove?: boolean) => void>,
    required: true,
  },
  contextmenus: {
    type: Function as PropType<() => ContextmenuItem[] | null>,
  },
})

const mainStore = useMainStore()
const selectElement = () => {
  mainStore.setActiveElementIdList([props.elementInfo.id])
}

const handleSelectElement = (e: MouseEvent | TouchEvent) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()

  props.selectElement(e, props.elementInfo)
}

const openDataEditor = () => {
  emitter.emit(EmitterEvents.OPEN_CHART_DATA_EDITOR)
}

const slideLayoutElement = computed(() => {
  return slidesStore.getElementsByType('slidelayout').find(layout => layout.id === props.elementInfo.slideLayoutId)
})

const width = computed(() => (props.elementInfo?.width ?? 0) + 'px')
const height = computed(() => (props.elementInfo?.height ?? 0) + 'px')

const px = (input, defaultValue) => {
  if (input !== undefined && input !== null) {
    return `${input}px`
  }
  else {
    return defaultValue
  }
}
</script>

<style lang="scss" scoped>
.editable-element-section {
  position: absolute;
  width: v-bind(width) !important;
  height: v-bind(height) !important;

  &.lock .element-content {
    cursor: default;
  }
}
.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
